(() => {
  if (window.vacdraAdaptiveHeader) return;
  window.vacdraAdaptiveHeader = true;
  const samples = new WeakMap();
  let pending = false;
  let lastUpdate = 0;
  const popupSelector = '#menu-drawer,.drawer__inner,.search-modal,#vx-wp .vx-wp__card,.disclosure__list-wrapper,.header__submenu,.predictive-search,.product-popup-modal__content,.product-media-modal__content,.cart-notification,.shopify-pc__banner__dialog,.shopify-pc__prefs__dialog';
  const excluded = '.vacdra-back-top,.section-header,.shopify-preview-bar,#preview-bar-iframe,#PBarNextFrame,#vx-wp,cart-drawer,.drawer,.drawer__overlay,.modal-overlay,.search-modal__overlay,product-modal,modal-dialog,' + popupSelector;
  const put = (el, name, value) => { if (el.closest('#vx-wp .vx-wp__body')) { const discountButton = el.closest('#vx-wp button[type="submit"]'); if (name === 'color' || name === '-webkit-text-fill-color') value = discountButton ? '#c9a86a' : '#fff'; if (el.matches('#vx-wp button[type="submit"]') && (name === 'background' || name === 'background-color')) value = '#000'; if (el.matches('#vx-wp button[type="submit"]') && name === 'border-color') value = '#000'; } if (el.style.getPropertyValue(name) !== value || el.style.getPropertyPriority(name) !== 'important') el.style.setProperty(name, value, 'important'); };
  const contrastAt = (surface, header) => {
    const r=surface.getBoundingClientRect();
    const values=[.2,.5,.8].flatMap(y=>[.2,.5,.8].map(x=>{
      const rgb=backgroundAt(Math.max(0,Math.min(innerWidth-1,r.left+r.width*x)),Math.max(0,Math.min(innerHeight-1,r.top+r.height*y)),header);
      return (rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722)/255;
    })).sort((a,b)=>a-b);
    return values[4] > (surface.dataset.vacdraPopup==='light' ? .56 : .64) ? 'light' : 'dark';
  };

  const adaptInstructionLines = (surface,header) => {
    const walker=document.createTreeWalker(surface,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode()) {
      const node=walker.currentNode;
      if(node.textContent.trim() && !node.parentElement.closest('[data-vacdra-word],script,style,svg,button')) nodes.push(node);
    }
    nodes.forEach(node=>{
      const fragment=document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(word=>{
        if(!word.trim()) fragment.append(document.createTextNode(word));
        else {
          const span=document.createElement('span');
          span.dataset.vacdraWord='';
          span.textContent=word;
          fragment.append(span);
        }
      });
      node.replaceWith(fragment);
    });
    const lines=new Map();
    surface.querySelectorAll('[data-vacdra-word]').forEach(word=>{
      const r=word.getBoundingClientRect();
      if(!r.width || r.bottom<0 || r.top>innerHeight) return;
      const key=Math.round(r.top/2)*2;
      if(!lines.has(key)) lines.set(key,[]);
      lines.get(key).push({word,r});
    });
    lines.forEach(words=>{
      const left=Math.min(...words.map(({r})=>r.left));
      const right=Math.max(...words.map(({r})=>r.right));
      const top=Math.min(...words.map(({r})=>r.top));
      const bottom=Math.max(...words.map(({r})=>r.bottom));
      const values=[.12,.32,.5,.68,.88].map(p=>{
        const rgb=backgroundAt(Math.max(0,Math.min(innerWidth-1,left+(right-left)*p)),Math.max(0,Math.min(innerHeight-1,(top+bottom)/2)),header);
        return (rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722)/255;
      }).sort((a,b)=>a-b);
      const previous=words[0].word.dataset.vacdraRowContrast;
      const mode=values[2]>(previous==='light' ? .56 : .64) ? 'light' : 'dark';
      const ink=mode==='light' ? '#000' : '#fff';
      words.forEach(({word})=>{
        word.dataset.vacdraRowContrast=mode;
        put(word,'background-image','none');
        put(word,'background-clip','border-box');
        put(word,'-webkit-background-clip','border-box');
        put(word,'-webkit-text-fill-color',ink);
        put(word,'color',ink);
      });
    });
    surface.querySelectorAll('button').forEach(button=>{
      const mode=contrastAt(button,header);
      put(button,'color',mode==='light'?'#000':'#fff');
    });
  };

  const adaptPopups = header => {
    document.querySelectorAll(popupSelector).forEach(surface=>{
      const r=surface.getBoundingClientRect();
      if (!r.width || !r.height || r.right<=0 || r.left>=innerWidth || r.bottom<=0 || r.top>=innerHeight || getComputedStyle(surface).visibility==='hidden') return;
      const instructions=!!surface.closest('#PopupModal-popup_KyWfqQ,#PopupModal-popup_aXUHhM');
      const mode=instructions ? 'dark' : contrastAt(surface,header);
      const ink=mode==='light' ? '#000' : '#fff';
      const rgb=mode==='light' ? '0,0,0' : '255,255,255';
      surface.dataset.vacdraPopup=mode;
      put(surface,'--vx-popup-ink',ink);
      put(surface,'--color-foreground',rgb);
      put(surface,'--color-link',rgb);
      put(surface,'--vx-glass-bg','linear-gradient(180deg,rgba(255,255,255,.16),rgba(255,255,255,.06))');
      put(surface,'--vx-glass-blur','blur(12px) saturate(150%)');
      put(surface,'background','linear-gradient(180deg,rgba(255,255,255,.16),rgba(255,255,255,.06))');
      put(surface,'backdrop-filter','blur(12px) saturate(150%)');
      put(surface,'-webkit-backdrop-filter','blur(12px) saturate(150%)');
      put(surface,'box-shadow',surface.closest('cart-drawer') ? '0 8px 24px rgba(0,0,0,.10)' : '0 8px 24px rgba(0,0,0,.10),inset 0 1px 1px rgba(255,255,255,.35)');
      put(surface,'text-shadow','none');
      [surface,...surface.querySelectorAll('*')].forEach(el=>{
        if (el.closest('[data-vacdra-popup]')!==surface) return;
        put(el,'color',el.closest('cart-drawer .vx-nudge') ? '#000' : ink);
        if(instructions) put(el,'border-color','rgba(255,255,255,.5)');
        put(el,'text-shadow','none');
        if (el.tagName.toLowerCase()==='svg' || el.classList.contains('svg-wrapper')) put(el,'filter','none');
        if (el.matches('input,select,textarea,button,.button') && !el.closest('.shopify-payment-button')) {
          put(el,'background-color',`rgba(${rgb},.08)`);
          put(el,'border-color',`rgba(${rgb},.28)`);
          put(el,'--color-button',rgb);
          put(el,'--color-button-text',mode==='light' ? '255,255,255' : '0,0,0');
        }
        if (el.matches('img.header__heading-logo,img[data-vacdra-logo]')) put(el,'filter',mode==='light' ? 'brightness(0)' : 'brightness(0) invert(1)');
      });
      if(instructions || surface.closest('cart-drawer') || surface.matches('#menu-drawer,.header__submenu,.disclosure__list-wrapper')) adaptInstructionLines(surface,header);
      if(surface.closest('cart-drawer')) surface.querySelectorAll('.quantity').forEach(quantity=>{
        put(quantity,'background',mode==='light'?'rgba(255,255,255,.82)':'rgba(15,18,21,.62)');
        put(quantity,'border','1px solid '+(mode==='light'?'rgba(0,0,0,.28)':'rgba(255,255,255,.45)'));
        quantity.querySelectorAll('button,input').forEach(control=>{
          put(control,'background','transparent');
          put(control,'color',ink);
          put(control,'-webkit-text-fill-color',ink);
        });
      });
    });
  };
  const color = value => {
    const m = value.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:\s*[,/]\s*([\d.]+))?\s*\)/);
    return m ? [+m[1], +m[2], +m[3], m[4] === undefined ? 1 : +m[4]] : null;
  };
  const mix = (top, base) => top.slice(0,3).map((v,i) => v * top[3] + base[i] * (1-top[3]));
  const picture = element => {
    if (samples.has(element)) return samples.get(element);
    samples.set(element, null);
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 64; canvas.height = 64;
        const ctx = canvas.getContext('2d', {willReadFrequently: true});
        ctx.drawImage(image, 0, 0, 64, 64);
        samples.set(element, {pixels: ctx.getImageData(0,0,64,64).data, width:image.naturalWidth, height:image.naturalHeight, src:element.currentSrc});
        schedule();
      } catch (_) {}
    };
    image.src = element.currentSrc || element.src;
    return null;
  };
  const backgroundAt = (x,y,header) => {
    const stack = document.elementsFromPoint(x,y).filter(el => !header.contains(el) && !el.closest(excluded));
    const target = stack[0];
    if (!target) return [255,255,255];
    const chain = [];
    for (let el=target; el; el=el.parentElement) chain.unshift(el);
    let rgb = [255,255,255];
    for (const el of chain) {
      const style = getComputedStyle(el);
      const bg = color(style.backgroundColor);
      if (bg) rgb = mix(bg,rgb);
      if (style.backgroundImage.includes('gradient(')) {
        const stops = [...style.backgroundImage.matchAll(/rgba?\([^)]+\)/g)].map(m=>color(m[0])).filter(Boolean);
        if (stops.length) {
          const mean = [0,1,2,3].map(i=>stops.reduce((v,c)=>v+c[i],0)/stops.length);
          rgb = mix(mean,rgb);
        }
      }
      if (el.tagName === 'VIDEO') rgb = [40,40,40];
      if (el.tagName === 'IMG') {
        const sample = picture(el);
        if (!sample) { rgb = [70,70,70]; continue; }
        if (sample.src !== el.currentSrc) { samples.delete(el); picture(el); }
        const rect = el.getBoundingClientRect();
        const cover = style.objectFit === 'cover';
        const contain = style.objectFit === 'contain';
        const scale = cover ? Math.max(rect.width/sample.width, rect.height/sample.height) : contain ? Math.min(rect.width/sample.width, rect.height/sample.height) : 0;
        const w=scale ? sample.width*scale : rect.width, h=scale ? sample.height*scale : rect.height;
        const px=(x-rect.left+(w-rect.width)/2)/w, py=(y-rect.top+(h-rect.height)/2)/h;
        if (px>=0 && px<=1 && py>=0 && py<=1) {
          const i=(Math.min(63,Math.floor(py*64))*64+Math.min(63,Math.floor(px*64)))*4;
          rgb=mix([sample.pixels[i],sample.pixels[i+1],sample.pixels[i+2],sample.pixels[i+3]/255],rgb);
        }
      }
    }
    return rgb;
  };
  const update = () => {
    pending=false;
    lastUpdate=performance.now();
    document.querySelectorAll('cart-drawer.active .drawer__inner').forEach(cart=>{
      [cart,...cart.querySelectorAll('*')].forEach(el=>{
        const ink=el.closest('.vx-nudge')?'#000':'#fff';
        put(el,'color',ink);
        if(el.matches('input,textarea,select')) put(el,'-webkit-text-fill-color',ink);
      });
    });
    document.querySelectorAll('.vx-nudge,.vx-nudge strong').forEach(el=>put(el,'color','#000'));
    const header=document.querySelector('.header-wrapper');
    if (!header) return;
    const r=header.getBoundingClientRect();
    if (!r.width || r.bottom<0) return;
    const values=[.12,.32,.5,.68,.88].map(p=>{
      const rgb=backgroundAt(Math.min(innerWidth-1,r.left+r.width*p),Math.max(0,Math.min(innerHeight-1,r.top+r.height/2)),header);
      return (rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722)/255;
    }).sort((a,b)=>a-b);
    const previous=header.dataset.vacdraContrast;
    const threshold=previous==='light' ? .56 : .64;
    header.dataset.vacdraContrast=values[2]>threshold ? 'light' : 'dark';
    adaptPopups(header);
    const backTop=document.querySelector('.vacdra-back-top');
    if(backTop){
      const mode=contrastAt(backTop,header);
      backTop.dataset.vacdraPopup=mode;
      put(backTop,'color',mode==='light'?'#000':'#fff');
      put(backTop,'background','linear-gradient(180deg,rgba(255,255,255,.16),rgba(255,255,255,.06))');
      put(backTop,'backdrop-filter','blur(12px) saturate(150%)');
      put(backTop,'-webkit-backdrop-filter','blur(12px) saturate(150%)');
    }
  };
  function schedule() {
    if (!pending) {
      pending=true;
      const delay=Math.max(0,80-(performance.now()-lastUpdate));
      setTimeout(()=>requestAnimationFrame(update),delay);
    }
  }
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class','open','hidden','aria-expanded','aria-hidden']});
  document.addEventListener('click',()=>{schedule();setTimeout(schedule,350);});
  document.addEventListener('transitionend',schedule);
  addEventListener('scroll',schedule,{passive:true});
  document.addEventListener('scroll',schedule,{capture:true,passive:true});
  addEventListener('resize',schedule,{passive:true});
  addEventListener('load',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('load',schedule,true);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',schedule); else schedule();
  const dismissible = 'cart-drawer.active .drawer__inner,details[open] > .search-modal,details[open] #menu-drawer,#vx-wp.is-open .vx-wp__card,modal-dialog[open] .product-popup-modal__content,product-modal[open] .product-media-modal__content';
  const openPopups = () => [...document.querySelectorAll(dismissible)].filter(el => {
    const r = el.getBoundingClientRect();
    return r.width && r.height && getComputedStyle(el).visibility !== 'hidden';
  });
  const insidePopup = (surface, target) => surface.contains(target) && !target.closest('.modal-overlay,.search-modal__overlay,.drawer__overlay,[data-vx-wp-close]:not(button)');
  const closePopup = (surface, event) => {
    const cart = surface.closest('cart-drawer');
    if (cart) return cart.close();
    const search = surface.closest('details-modal');
    if (search) return search.close();
    const welcome = surface.closest('#vx-wp');
    if (welcome) return welcome.querySelector('button[data-vx-wp-close],[data-vx-wp-close]').click();
    const modal = surface.closest('modal-dialog,product-modal');
    if (modal) return modal.hide();
    const menu = surface.closest('header-drawer,menu-drawer');
    const details = surface.closest('details[open]');
    if (menu && details) {
      const toggle=details.querySelector(':scope > summary');
      toggle.setAttribute('aria-expanded','false');
      return menu.closeMenuDrawer(event,toggle);
    }
  };
  document.addEventListener('click', event => {
    const popups = openPopups();
    if (!popups.length || popups.some(surface => insidePopup(surface,event.target))) return;
    if (event.target.closest('.shopify-preview-bar,#preview-bar-iframe,#PBarNextFrame')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    popups.reverse().forEach(surface=>closePopup(surface,event));
  }, true);
  window.addEventListener('scroll',event=>{
    if(event.target!==document && event.target!==window) return;
    if(!openPopups().length) return;
    event.stopImmediatePropagation();
    schedule();
  },{capture:true,passive:true});
})();
